import toAdditionalSettingsCategories from "../dto/toAdditionalSettingsCategories";

function filterByNotificationTypes(categories, notificationTypes) {
  return categories.filter(({ key }) => notificationTypes.includes(key));
}

/**
 *
 * @param {{
 *   notificationTypes: string[],
 *   configAlertCategories: { key: string, name: string }[],
 *   apiSettingsCategories: {
 *     notifications_unique_id: string,
 *     name: string,
 *     notifications_enabled_by_default?: boolean
 *   }[]
 * }} params
 */
export function getStrategyDashboardSettingsCategories({
  notificationTypes,
  configAlertCategories = [],
  apiSettingsCategories = []
}) {
  return {
    alertCategories: filterByNotificationTypes(
      configAlertCategories,
      notificationTypes
    ),
    additionalSettingsCategories: filterByNotificationTypes(
      toAdditionalSettingsCategories({
        settingsCategories: apiSettingsCategories
      }),
      notificationTypes
    )
  };
}
